// Mock data for Open Concierge Desk for Seniors

export const services = [
  {
    id: 1,
    title: "Doctor Appointment Accompaniment",
    description: "We accompany seniors to medical appointments, ensuring they have support throughout the visit and help communicate with healthcare providers.",
    icon: "Stethoscope",
    accent: "accent-pink"
  },
  {
    id: 2,
    title: "Regular Wellbeing Check-ins",
    description: "Friendly visits to check on your loved one's health, mood, and daily needs. We keep families informed and connected.",
    icon: "Heart",
    accent: "accent-green"
  },
  {
    id: 3,
    title: "Grocery & Medicine Assistance",
    description: "Help with grocery shopping, picking up prescriptions, and ensuring seniors have all their daily essentials.",
    icon: "ShoppingBag",
    accent: "accent-orange"
  },
  {
    id: 4,
    title: "Paperwork & Bill Payment Support",
    description: "Assistance with organizing documents, filling forms, paying utility bills, and managing everyday paperwork.",
    icon: "FileText",
    accent: "accent-blue"
  },
  {
    id: 5,
    title: "Light Errands & Daily Help",
    description: "From post office runs to bank visits, we handle small errands that make daily life easier and more comfortable.",
    icon: "Package",
    accent: "accent-purple"
  },
  {
    id: 6,
    title: "Family Coordination & Updates",
    description: "We keep family members informed about their loved one's wellbeing with regular updates and coordination on their care.",
    icon: "Users",
    accent: "accent-grey"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Reach Out to Us",
    description: "Contact us through our form, WhatsApp, or email. Tell us what help you need and we'll understand your situation."
  },
  {
    step: 2,
    title: "We Discuss Your Needs",
    description: "Our team will call you to understand the details and discuss how we can help. We'll share the expected cost upfront."
  },
  {
    step: 3,
    title: "Confirm & Schedule",
    description: "Once you're comfortable with the plan and pricing, we schedule the service at a time convenient for you."
  },
  {
    step: 4,
    title: "Personal Assistance Delivered",
    description: "Our caring team member arrives to provide the help needed. Families receive updates throughout."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya S.",
    relation: "Daughter",
    quote: "Living abroad, I was always worried about my mother. Open Concierge Desk gives me peace of mind knowing someone trustworthy is there when she needs help.",
    location: "Mumbai"
  },
  {
    id: 2,
    name: "Rajesh K.",
    relation: "Son",
    quote: "They helped my father with his hospital visits and paperwork. The team is patient, respectful, and truly cares about seniors.",
    location: "Bangalore"
  },
  {
    id: 3,
    name: "Mrs. Sharma",
    relation: "Senior",
    quote: "I don't feel like a burden anymore. When I need help with shopping or bills, I just call them. They treat me like family.",
    location: "Delhi"
  }
];

export const faqs = [
  {
    question: "How does the pricing work?",
    answer: "We follow a simple pay-as-you-use model. There are no subscriptions or commitments. The cost depends on the type of help, time involved, and location. We always share and confirm the price before any service is delivered."
  },
  {
    question: "Do I need to download an app or create an account?",
    answer: "No. We keep things simple. Just reach out via our form, WhatsApp, or email. No app, login, or registration required."
  },
  {
    question: "How do I pay for services?",
    answer: "Payment is made after the service is completed. We accept UPI, bank transfer, and cash. No advance payment is required."
  },
  {
    question: "Can I request help for my parent who lives in another city?",
    answer: "Yes, absolutely. Many of our clients are adult children living away from their parents. We provide updates and coordination so you stay informed."
  },
  {
    question: "What areas do you serve?",
    answer: "We currently serve major metropolitan areas across India. Contact us to check availability in your city."
  },
  {
    question: "Are your team members trained?",
    answer: "Yes. All our team members are trained in senior care, communication, and assistance. They are background-verified and selected for their patience and empathy."
  }
];

export const contactInfo = {
  email: "ahirwarb@gmail.com",
  phone: "+91 96199 98944",
  whatsapp: "919619998944",
  hours: "9:00 AM – 9:00 PM IST (All days)"
};

export const helpFormOptions = {
  helpFor: [
    { value: "self", label: "Myself" },
    { value: "parent", label: "My Parent" },
    { value: "relative", label: "A Relative" }
  ],
  helpTypes: [
    { value: "doctor-appointment", label: "Doctor Appointment Accompaniment" },
    { value: "wellbeing-checkin", label: "Wellbeing Check-in" },
    { value: "grocery-medicine", label: "Grocery & Medicine Help" },
    { value: "paperwork-bills", label: "Paperwork & Bill Payment" },
    { value: "errands", label: "Light Errands" },
    { value: "family-coordination", label: "Family Coordination" },
    { value: "other", label: "Other (Please specify in notes)" }
  ],
  contactMethods: [
    { value: "call", label: "Phone Call" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "email", label: "Email" }
  ]
};